<template>
  <div>
    <!-- <form data-vv-scope="Enrollment"> -->

    <form data-vv-scope="Enrollment">
      <div class="mb-2">
        <!-- <pre>{{settingObject}}</pre> -->

        <label>Course List</label>
        <v-select
          class="w-full"
          label="name"
          :reduce="(option) => option.id"
          :options="courseList"
          v-model="selected_course_id"
          :clearable="false"
          placeholder="Enter Course Name"
          name="CourseName"
          data-vv-name="CourseName"
          v-validate="'required'"
        ></v-select>
        <div
          v-if="errors.has(`Enrollment.CourseName`)"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first(`Enrollment.CourseName`) }}
        </div>
      </div>
      <!-- {{teacherList}} -->
      <!-- <div class="mb-2">
        <label>Teacher List</label>
        <v-select class="w-full"> </v-select>
      </div> -->
      <div class="mb-2">
        <label>Teacher List</label>
        <v-select
          class="w-full"
          label="first_name"
          :reduce="(option) => option.id"
          :options="teacherList"
          v-model="teacher_id"
          :clearable="false"
          placeholder="Enter Teacher Name"
          name="Teacher Name"
          data-vv-name="Teacher Name"
                    v-validate="'required'"

        ></v-select>

        <div
          v-if="errors.has(`Enrollment.Teacher Name`)"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first(`Enrollment.Teacher Name`) }}
        </div>
      </div>
      <div class="mb-2">
        <label>Students List</label>
        <!-- {{studentList}} -->
        <v-select
          class="w-full"
          :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
          :options="studentList"
          :reduce="(option) => option.client_users_id"
          v-model="selectStudentId"
          placeholder="Select Students"
          name="Student Name"
          data-vv-name="Student Name"
                    v-validate="'required'"

        ></v-select>

        <div
          v-if="errors.has(`Enrollment.Student Name`)"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first(`Enrollment.Student Name`) }}
        </div>
      </div>

      <!--  <div class="mb-2">
        <label>Teacher List</label>
        <v-select class="w-full"> </v-select>
      </div> -->

      <!-- <div class="mb-2">
        <label>WeekDay</label>
        <v-select multiple class="w-full"> </v-select>
          <v-select
            multiple
            :options="weekOption"
            v-model="session_frequency_week_day"
            v-validate="'required'"
            class="w-full my-2"
            name="session_frequency_week_day"
            data-vv-name="session_frequency_week_day"
            v-on:input="limiter"

          >
          </v-select>
      </div> -->

      <div v-if="settingObject && settingObject.session_frequency == '2'">
        <label><strong>WeekDay</strong></label>
        <v-select
          multiple
          :options="weekOption"
          v-model="session_frequency_week_day"
          v-validate="'required'"
          class="w-full my-2"
          name="session_frequency_week_day"
          data-vv-name="session_frequency_week_day"
          v-on:input="limiter"
        >
        </v-select>
        <div
          v-if="errors.has(`Enrollment.session_frequency_week_day`)"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first(`Enrollment.session_frequency_week_day`) }}
        </div>
      </div>
      <div v-if="settingObject && settingObject.session_frequency == '4'">
        <label><strong>Monthday</strong></label>
        <v-select
          multiple
          v-if="settingObject && settingObject.session_frequency == '4'"
          :options="monthDay"
          v-model="session_frequency_month_day"
          v-validate="'required'"
          name="session_frequency_month_day"
          data-vv-name="session_frequency_month_day"
        >
        </v-select>
        <div
          v-if="errors.has(`Enrollment.session_frequency_month_day`)"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first(`Enrollment.session_frequency_month_day`) }}
        </div>
      </div>

      <label class="w-full my-2">Start Date</label>
      <flat-pickr
        v-model="course_start_date"
        class="w-full my-2"
        :config="configStartDate"
        name="start_date"
        data-vv-name="start_date"
        v-validate="'required'"
      ></flat-pickr>

                       
        <div
        v-if="errors.has(`Enrollment.start_date`)"
        style="color: red"
        class="invalid-feedback"
      >
        {{ errors.first(`Enrollment.start_date`) }}
      </div>

      <label>Course Timing</label>
      <v-select
        v-model="course_start_time"
        class="w-full my-2"
        name="start_timing"
        data-vv-name="start_timing"
        v-validate="'required'"
        :options="selectTiming"
      ></v-select>
       <div
        v-if="errors.has(`Enrollment.start_timing`)"
        style="color: red"
        class="invalid-feedback"
      >
        {{ errors.first(`Enrollment.start_timing`) }}
      </div>
      <!-- <div class="mb-2">
        <label>Start Date</label>
        <flat-pickr
          v-model="course_start_date"
          class="w-full"
          :config="configStartDate"
          name="start_date"
          data-vv-name="start_date"
        ></flat-pickr>
      </div>

      <div class="mb-2">
        <label class="w-full my-2">Start Time</label>
        <flat-pickr
          v-model="course_start_time"
          class="w-full my-2"
          :config="configStartTiming"
          name="start_timing"
          data-vv-name="start_timing"
          v-validate="'required'"
        ></flat-pickr>
      </div> -->

      <vs-button
      @click.prevent="enRolledValidate()"
      >Save Enrollment</vs-button>
    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { GlobalCourseMixin } from '@/mixins/course/GlobalCourseMixin'
import {enrollmentApi} from '@/api/course-builderapi'

export default {
  components: {
    vSelect,
    flatPickr
  },
  mixins: [GlobalCourseMixin],
  name: 'ScheduleOneToComponent',
  data () {
    return {
      selected_course_id: null,
      session_frequency_week_day: [],
      session_frequency_month_day: [],
      configStartDate: {
        dateFormat: 'Y-m-d',
        onChange: (selectedDates, dateStr, instance) => {
          this.getTiming()

          //...
        }
      }
    }
  },
  watch: {
    selected_course_id () {
      const selectedCourse = this.courseList.filter((ele) => {
        return ele.id === this.selected_course_id
      })
      this.teacher_id = null
      this.settingObject = null
      this.teacherList = selectedCourse[0].instructors
      this.settingObject = selectedCourse[0].courseSettings
      this.session_frequency_week_day = this.settingObject.session_frequency_week_day
      this.session_frequency_month_day = this.settingObject.session_frequency_month_day
      this.max_days_in_week_or_month = this.settingObject.max_days_in_week_or_month
      this.course_start_date = ''
      this.course_start_time = ''
      this.selectTiming.splice(0)
    }
  },
  created () {
    this.fetchCourseWithList('online_one_2_one')
    this.getStudentList()
  },
  methods: {
    checkingSelectionWeekdays () {
      
      if (
        this.settingObject.session_frequency == '2' &&
        this.max_days_in_week_or_month ===
          this.session_frequency_week_day.length
      ) {
        return true
      } else if (
        this.settingObject.session_frequency == '4' &&
        this.max_days_in_week_or_month ===
          this.session_frequency_month_day.length
      ) {
        return true
      } else {
        return false
      }
    },
    enRolledValidate () {
      this.$validator.validateAll('Enrollment').then((response) => {
        
        if (response) {
          let hasSelectWeekDays = true
          hasSelectWeekDays =  this.checkingSelectionWeekdays()
          if (hasSelectWeekDays) {
            const payload = {
              course_id: this.selected_course_id,
              course_start_date: this.course_start_date,
              course_start_time: this.course_start_time,
              session_frequency_week_day: this.session_frequency_week_day,
              session_frequency_month_day: this.session_frequency_month_day,
              teacher_id: this.teacher_id,
              clientUser:[this.selectStudentId]

            
            }
            this.EnrolledCourse(payload)
          } else {
            let message = ''
            if (this.settingObject.session_frequency == 2) {
              message = `Must select ${this.max_days_in_week_or_month} in weekdays`
            } else if (this.settingObject.session_frequency == 4) {
              message = `Must select ${this.max_days_in_week_or_month} in monthly`

            }
            this.showSuccessMessage('Error', message, 'danger')
          }
          
        } else {
          this.showSuccessMessage('Error', 'Validation Is Required', 'danger')
          
        }
      })
    },
    async EnrolledCourse (payload) {
      
          
        
      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await enrollmentApi(payload, customer_id)
        
        this.showSuccessMessage('Success', 'The course has been Set And Enrolled For the Student', 'success')

        this.$emit('scheduleAdded')

        // this.$emit('submitEnrolled', true)
      } catch (api_error) {
        
        this.showSuccessMessage('Error', `${api_error.data.message}`, 'danger')
        
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
</style>